import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-farewell-party-twentyfive',
  templateUrl: './farewell-party-twentyfive.component.html',
  styleUrls: ['./farewell-party-twentyfive.component.scss']
})
export class FarewellPartyTwentyfiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
